import styles from "../styles/login.module.scss";
import { useEffect, useRef, useState } from "react";
import { Button, Divider, Input } from "antd-mobile";
import { ShowMessage } from "../components/ShowMessage/ShowMessage";
import http from "../http";

export default function Login(props: { success: () => void }) {
  const [read, setRead] = useState(true);
  const [loginDisable, setLoginDisable] = useState(false);
  const [loginData, setLoginData] = useState({
    phoneNumber: "",
    code: "",
  });
  const [loadingTime, setLoadingTime] = useState(60);
  const [codeLoading, setCodeLoading] = useState(false);
  const [isSended, setIsSended] = useState(false);
  const timer = useRef<any>();
  const [loginLoading, setLoginLoading] = useState(false);
  const [registerLoading, setRegisterLoading] = useState(false);
  useEffect(() => {
    setLoginDisable(
      !!loginData.phoneNumber &&
        !!loginData.code &&
        /^1[3456789]\d{9}$/.test(loginData.phoneNumber) &&
        /^\d{6}$/.test(loginData.code) &&
        read
    );
  }, [loginData, read]);

  useEffect(() => {
    if (loadingTime <= 0) {
      clearInterval(timer.current);
      setCodeLoading(false);
    }
    if (codeLoading) {
      timer.current = setTimeout(() => {
        setLoadingTime(loadingTime - 1);
      }, 1000);
    }
    return () => {
      timer.current && clearTimeout(timer.current);
    };
  }, [codeLoading, loadingTime]);

  const openUserAgreement = () => {
    window.open("/userargreement", "_blank");
  };

  const openPrivacyPolicy = () => {
    window.open("/privacypolicy", "_blank");
  };
  const phoneChange = (value: string) => {
    loginData.phoneNumber = value;
    setLoginData({ ...loginData });
  };
  const codeChange = (value: string) => {
    loginData.code = value;
    setLoginData({ ...loginData });
  };
  const sendCode = () => {
    if (!loginData.phoneNumber) {
      ShowMessage.error("请输入手机号");
      return;
    } else if (!/^1[3456789]\d{9}$/.test(loginData.phoneNumber)) {
      ShowMessage.error("请输入正确的手机号");
      return;
    }
    waitCodeLoading();
    http
      .post("/api/v1/account/code", { phone_number: loginData.phoneNumber })
      .then((res: any) => {
        if (res.status) {
        } else {
          ShowMessage.error(res.message);
        }
      });
  };
  const waitCodeLoading = () => {
    setLoadingTime(60);
    setIsSended(true);
    setCodeLoading(true);
  };

  const registerLogin = () => {
    setRegisterLoading(true);
    http
      .post(
        sessionStorage.getItem("invite_code")
          ? `/api/v1/account/mobile_register?invite_code=${
              sessionStorage.getItem("invite_code") || ""
            }`
          : `/api/v1/account/mobile_register`,
        {
          phone_number: loginData.phoneNumber,
          sms_code: loginData.code,
          bd_vid: sessionStorage.getItem("bd_vid") || "",
        }
      )
      .then((res: any) => {
        if (res.status) {
          window.localStorage.setItem("token", res.data.token);
          if (res.data.is_new) {
            http.post(`/api/v1/account/utm-source `, {
              utm_source: sessionStorage.getItem("utm_source") || "",
              phone_number: res.data.phone_number,
            });
          }
          props.success();
          loginData.code = "";
          setLoginData({ ...loginData });
          ShowMessage.success(res.message);
        } else {
          ShowMessage.error(res.message);
        }
        setRegisterLoading(false);
      });
  };
  return (
    <div className={styles.login_body}>
      <div className={styles.login_title}>登录</div>
      <div className={styles.login_form}>
        <div
          className={`${styles.login_form_phone} ${styles.login_form_input}`}
        >
          <div className={styles.suffix}>
            +86
            <Divider direction="vertical" />
          </div>
          <Input
            placeholder="请输入手机号"
            value={loginData.phoneNumber}
            maxLength={11}
            onChange={phoneChange}
            className={styles.phone_input}
          />
        </div>
        <div className={`${styles.login_form_code} ${styles.login_form_input}`}>
          <Input
            placeholder="请输入验证码"
            value={loginData.code}
            onChange={codeChange}
            maxLength={6}
            className={styles.code_input}
          />
          <Button
            color="primary"
            disabled={
              !/^1[3456789]\d{9}$/.test(loginData.phoneNumber) || codeLoading
            }
            fill="none"
            className={styles.send_code}
            onClick={sendCode}
          >
            {!isSended
              ? "发送验证码"
              : `重新发送${!!loadingTime ? `(${loadingTime})` : ""}`}
          </Button>
        </div>
      </div>
      <div className={styles.read}>
        <span
          className={`${styles.checkbox} ${read ? styles.active : ""}`}
          onClick={() => {
            setRead(!read);
          }}
        ></span>
        阅读并接受{" "}
        <span className={styles.link} onClick={openUserAgreement}>
          &lt;用户协议&gt;
        </span>
        <span className={styles.conjunction}>和</span>
        <span className={styles.link} onClick={openPrivacyPolicy}>
          &lt;隐私政策&gt;
        </span>
      </div>
      <Button
        block
        disabled={!loginDisable && !registerLoading}
        color="primary"
        shape="rounded"
        size="large"
        className={styles.login_btn}
        onClick={registerLogin}
        loading={loginLoading}
        loadingText="正在登录"
      >
        登录 / 注册
      </Button>
    </div>
  );
}
